import { Grid } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import ThirdpartyDataHub from '../../../../containers/thirdparties/thirdparty-sheet/ThirdpartyDataHub';

function DataHubSection({ display, title, thirdPartyId, isUnmanaged }) {
  const { classes } = useStyles();
  const [isExpanded, setExpanded] = React.useState(true);

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"datahub"}>
      <EAAccordion
        title={title}
        logo="thirdparty/datahub"
        titleNoResult
        opened={isExpanded}
      >
        <ThirdpartyDataHub
          thirdPartyId={thirdPartyId}
          setExpanded={setExpanded}
          isUnmanaged={isUnmanaged}
        />

      </EAAccordion>
    </Grid>
  );
}

export default DataHubSection;
